export default "__VITE_ASSET__5585ed4b__"